'use strict';

const { CLASSES } = require('./../utils/globals');
const SELECTORS = {
    eyeButton: '.js-showpassword',
    inputField: '.js-input-field',
}

/**
 * @description Initializes the password show/hide functionality
 */

function passwordShow() {
    const eyeButtons = Array.from(document.querySelectorAll(SELECTORS.eyeButton));
    eyeButtons.forEach(eyeButton => {
        eyeButton.addEventListener('click', function () {
            const $this = $(this);

            eyeButton.classList.toggle(CLASSES.active);

            const $input = $this.siblings(SELECTORS.inputField);

            if ($input.length) {
                const isPasswordType = $input.attr('type') === 'password';
                const showPasswordTitle = $this.data('title-show');
                const hidePasswordTitle = $this.data('title-hide');
                $input.attr('type', isPasswordType ? 'text' : 'password');
                $this.attr('title', isPasswordType ? hidePasswordTitle : showPasswordTitle);
            }
        });
    });
}

module.exports = passwordShow();
